export const ModelB = {
    name :  { path: ".name" },
    type : { 
        path: ".n/a",
        _default: {
            datetime: 'date',
            time: "date",
            date: "date",
            video: "video",
            signature: "signature",
            location: "geo",
            map: "map",
            geo: "geo",
            boolean: "boolean",
            datasource: "datasource",
            multiInput: "input",
            info: "label",
            subform: "subform"
        },
        fieldValidate: '.type',
        valuesValidate: ["datetime", "time", "date", "video","signature", "location", "map", "geo", "boolean", "datasource", "multiInput", "info", "subform"]
    },
    label : { path: ".label" },
    required : { path: ".required" },
    inputType : { 
        path: {
            map: '.inputType',
            geo: '.inputType',
            location: '.n/a',
            time: '.n/a',
            datetime: '.n/a',
            date: '.n/a',
            video: '.n/a',
            signature: '.n/a', 
            datasource: '.n/a',  
            multiInput: '.n/a'        
        },  
        _default: {
            datetime: 'datetime',
            time: "time",
            date: "calendar",
            video: "url",
            signature: "sign",
            location: "location",
            boolean: "standar",
            datasource: "standar",
            multiInput: "multiInput",
            info: "info",
            subform: "standar"
        }, 
        fieldValidate: '.type',
        valuesValidate: ["datetime", "time", "date", "video", "signature","location", "map", "geo", "boolean", "datasource", "multiInput", "info","subform"]
    },
    help: {
        path: ".help",
        _default: ""
    },
    content: { 
        path: ".content",
        _default: 'DEFAULT',
        fieldValidate: '.type',
        valuesValidate: ["video", "map"]
    },
    key: { 
        path: ".key",
        _default: 'DEFAULT',
        fieldValidate: '.type',
        valuesValidate: ["map", "geo"]
    },
    properties: {
        path: ".properties",
        fieldValidate: '.type',
        valuesValidate: ["datetime", "time", "date", "signature", "geo", "datasource", "multiInput", "info", "subform"],
        _properties: { 
            min: {
                path: {
                    multiInput: ".n/a",
                    subform:  ".n/a"          
                },
                _default:  1,//Si el componente no tiene la propiedad min
                fieldValidate: '.type',
                valuesValidate: ["multiInput", "subform"]
            },
            max: {
                path: {
                    multiInput: '.n/a',
                    subform:  ".n/a"
                },
                _default: 1,//Si el componente no tiene la propiedad max
                fieldValidate: '.type',
                valuesValidate: ["multiInput", "subform"]
            },
            color: {
                path: ".n/a",
                _default: "#000000",
                fieldValidate: '.type',
                valuesValidate: ["signature"]
            },
            default: {
                path: {
                    geo: '.content',
                    time: '.n/a',
                    datetime: '.n/a',
                    info: ".n/a"
                },
                _default: {
                    time: "AM/PM",
                    datetime: "AM/PM",
                    datasource: "write",
                    info: "datasource"      
                },//Si el componente no tiene la propiedad default
                fieldValidate: '.type',
                valuesValidate: ["time", "datetime", "geo", "datasource", "info"]
            },
            minValue: {
                 path:'n/a',
                _default: {
                    datetime: 2020,
                    date: 2020             
                },
                fieldValidate: '.type',
                valuesValidate: ["datetime", "date"],
            },
            maxValue: {
                path:'n/a',
                _default: {
                    datetime: 2021,
                    date: 2021             
                },
                fieldValidate: '.type',
                valuesValidate: ["datetime", "date"],
            },  
            limit: {
                path: ".properties.limit",
                _default: 20,//Si el componente no tiene la propiedad orientation
                fieldValidate: '.type',
                valuesValidate: ["datasource"]
            },
            originKey: {
                path: ".n/a",
                _default: "_is_Null_Origin_Key_",//Si el componente no tiene la propiedad orientation
                fieldValidate: '.type',
                valuesValidate: ["datasource"]
            },
            searchField: {
                path: ".properties.searchField",
                _default: "DEFAULT",//Si el componente no tiene la propiedad orientation
                fieldValidate: '.type',
                valuesValidate: ["datasource"]
            },          
        }         
    },
    data: {
        path: ".data",
        _default: [],
        fieldValidate: '.type',
        valuesValidate: ["datasource", "info"]
    },
    inherited: {
        path: ".inherited",
        _default: [],
        fieldValidate: '.type',
        valuesValidate: ["subform"]
    },

}